import {Button, SearchBar, Tab} from '@kaman/uikit';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {setSheetHeader} from '../../redux/sheetHeader/sheetHeaderSlice';
import {useQuery} from 'react-query';
import {
    GetOfflineStoresSections,
    GetOnlineStoresSections,
    STALE_10_MIN,
    STORE_QUERY_KEYS,
} from '../../services/store.service';
import {SectionRenderer} from './components/sectionRenderer';
import {SearchBarCmp} from './components/searchBarCmp';
import {SECTION_SPACING} from './components/sectionSpacing';

const Home = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tabValue, setTabValue] = useState('first');

    const tabItems = [
        {label: 'آنلاین', value: 'first'},
        {label: 'حضوری', value: 'second'},
    ];
    const {data: onlineData, isLoading: OnlineIsLoading} = useQuery(
        STORE_QUERY_KEYS.onlineSections,
        GetOnlineStoresSections,
        {staleTime: STALE_10_MIN}
    );
    const {data: offlineData, isLoading: OfflineIsLoading} = useQuery(
        STORE_QUERY_KEYS.offlineSections,
        GetOfflineStoresSections,
        {staleTime: STALE_10_MIN}
    );

    useEffect(() => {
        const activeLabel =
            tabItems.find((t) => t.value === tabValue)?.label ?? '';
        dispatch(
            setSheetHeader({
                title: 'فروشگاه ' + activeLabel,
                showBack: false,
                showShare: false,
                contentOverlap: false,
                headerHeight: 'auto',
                contentPadding: '16px',
            })
        );
    }, [dispatch, tabValue]);

    const selectStore = (storeId: number) => {
        navigate(`/home/store-detail?storeId=${storeId}`);
    };

    const navigateToRoute = (route?: string | null) => {
        if (!route) return;
        if (/^https?:\/\//i.test(route)) {
            window.open(route, '_blank', 'noopener,noreferrer');
            return;
        }
        navigate(route);
    };

    return (
        <div
            className="w-full min-w-0 flex flex-col items-center overflow-x-hidden"
            style={{gap: SECTION_SPACING}}
        >
            <Tab
                className="w-full [&>button]:bg-[#F6F6F6] [&>button]:border-0 [&>button.border]:bg-[#EFFDFF] [&>button.border]:border [&>button.border]:border-[#282727] [&>button.border]:shadow-none [&>button.border>*]:text-[#282727]"
                defaultValue="first"
                value={tabValue}
                onChange={(v) => setTabValue(String(v))}
                items={tabItems}
            />

            {tabValue === 'first' && (
                <div
                    className="w-full min-w-0 flex flex-col items-center overflow-x-hidden"
                    style={{gap: SECTION_SPACING}}
                >
                    <SearchBarCmp
                        label="آنلاین"
                        onClick={() => navigate('/home/online-search')}
                    />
                    {onlineData?.map((section, index) => (
                        <div
                            key={`online-${index}`}
                            className="w-full min-w-0 overflow-x-hidden"
                        >
                            <SectionRenderer
                                section={section}
                                onNavigate={navigateToRoute}
                                storeChannel="online"
                            />
                        </div>
                    ))}
                </div>
            )}

            {tabValue === 'second' && (
                <div
                    className="w-full min-w-0 flex flex-col items-center overflow-x-hidden"
                    style={{gap: SECTION_SPACING}}
                >
                    <SearchBarCmp
                        label="حضوری"
                        onClick={() => navigate('/home/offline-search')}
                    />
                    {offlineData?.map((section, index) => (
                        <div
                            key={`offline-${index}`}
                            className="w-full min-w-0 overflow-x-hidden"
                        >
                            <SectionRenderer
                                section={section}
                                onNavigate={navigateToRoute}
                                storeChannel="offline"
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Home;
